import { render } from "./DoctorDetailSkeleton.vue?vue&type=template&id=ac4192ec"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__